import React, { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Alert from '../../Alert';
import Button from '@mui/material/Button';
import Branches from './Branches';
import Records from './Records';
import Prebranch from './Prebranch';
import CircularProgress from '@mui/material/CircularProgress';
import SectionTitle from '../../SectionTitle';
import getBranch from '../../Queries/getBranch';

// Styles
import styles from './index.module.sass';

const Branch = (props) => {
  const { device, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('branch');

  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [loading, setLoading] = useState(false);
  const [optionSelected, setOptionSelected] = useState('PREBRANCH');
  const [branches, setBranches] = useState({});
  const [records, setRecords] = useState([]);
  const [prebranch, setPrebranch] = useState({});
  const yearBase = new Date().getFullYear();
  const [yearSelected, setYearSelected] = useState(yearBase);
  const [monthSelected, setMonthSelected] = useState(new Date().getMonth() + 1);

  const getBranchInfo = useCallback(
    async (anioSelected, mesSelected) => {
      setLoading(true);
      const anio = anioSelected || new Date().getFullYear();
      const mes = mesSelected || new Date().getMonth() + 1;

      const response = await getBranch(optionSelected, anio, mes);

      const { tipoMensaje = 'error', branch = {}, historial = [], mensaje = '' } = response;

      setSessionMessage(mensaje);
      if (tipoMensaje === 'error' && mensaje !== '498' && mensaje !== '499') {
        setAlertText(mensaje);
        setOpen(true);
      } else {
        if (optionSelected === 'BRANCH') setBranches(branch);
        if (optionSelected === 'HISTORIAL') setRecords(historial);
        if (optionSelected === 'PREBRANCH') setPrebranch(response);
      }
      setLoading(false);
    },
    [optionSelected, setSessionMessage],
  );

  const handleChange = (option) => {
    if (loading) return;
    setOptionSelected(option);
  };

  useEffect(() => {
    getBranchInfo();
  }, [getBranchInfo]);

  return (
    <div id={styles.Branch} className={styles[screenSize]}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('title')} subtitle='' />
      <div className={styles.container}>
        <div className={styles.tables}>
          {(loading && (
            <div className={styles.loading}>
              <CircularProgress className={styles.circularProgress} />
            </div>
          )) ||
            (optionSelected === 'BRANCH' && (
              <Branches branches={branches} setSessionMessage={setSessionMessage} />
            )) ||
            (optionSelected === 'HISTORIAL' && (
              <Records
                records={records}
                screenSize={screenSize}
                setSessionMessage={setSessionMessage}
              />
            )) ||
            (optionSelected === 'PREBRANCH' && (
              <Prebranch
                records={records}
                screenSize={screenSize}
                prebranch={prebranch}
                getBranchInfo={getBranchInfo}
                yearSelected={yearSelected}
                setYearSelected={setYearSelected}
                monthSelected={monthSelected}
                setMonthSelected={setMonthSelected}
                yearBase={yearBase}
                setSessionMessage={setSessionMessage}
              />
            ))}
        </div>

        <div className={styles.buttons}>
          <div className={styles.buttonContainer}>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={`${styles.button} ${styles[optionSelected === 'BRANCH']} ${
                styles.selectButton
              }`}
              onClick={(e) => handleChange('BRANCH')}>
              <span className={`material-icons-outlined ${styles.buttonIcon}`}>schema</span>
              {t('branchButton')}
            </Button>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={`${styles.button} ${styles[optionSelected === 'HISTORIAL']} ${
                styles.selectButton
              }`}
              onClick={(e) => handleChange('HISTORIAL')}>
              <span className={`material-icons-outlined ${styles.buttonIcon}`}>history</span>
              {t('recordButton')}
            </Button>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={`${styles.button} ${styles[optionSelected === 'PREBRANCH']} ${
                styles.selectButton
              }`}
              onClick={(e) => handleChange('PREBRANCH')}>
              <span className={`material-icons-outlined ${styles.buttonIcon}`}>
                radio_button_unchecked
              </span>
              {t('prebranchButton')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Branch;
